import { render, staticRenderFns } from "./freight-dialog.vue?vue&type=template&id=0e4a5861&scoped=true&"
import script from "./freight-dialog.vue?vue&type=script&lang=js&"
export * from "./freight-dialog.vue?vue&type=script&lang=js&"
import style0 from "./freight-dialog.vue?vue&type=style&index=0&id=0e4a5861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a5861",
  null
  
)

export default component.exports